module.exports = __webpack_public_path__ + "media/images/img-zero2-1@2x-d8f621389f29a668c2a9de3c12f8b103.png";